function debounce(func, delay = 300) {
	let timer;
	return (...args) => {
		clearTimeout(timer);
		timer = setTimeout(() => func.apply(this, args), delay);
	};
}

function fetchConfig(type = 'json') {
	return {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'Accept': `application/${type}`,
		},
	};
}

function waitForElement(selector, rootSearchElement = document, rootObserveElement = document.body) {
	return new Promise((resolve) => {
		if (rootSearchElement.querySelector(selector)) {
			return resolve(rootSearchElement.querySelector(selector));
		}
		const observer = new MutationObserver((mutations) => {
			if (rootSearchElement.querySelector(selector)) {
				resolve(rootSearchElement.querySelector(selector));
				observer.disconnect();
			}
		});
		observer.observe(rootObserveElement, {
			childList: true,
			subtree: true,
		});
	});
}

function hexToRgb(hex) {
	const match = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	if (!match) {
		return null;
	}

	const red = parseInt(match[1], 16);
	const green = parseInt(match[2], 16);
	const blue = parseInt(match[3], 16);

	return `rgb(${red}, ${green}, ${blue})`;
}

function initClipboardCopyButtons() {
	const buttons = document.querySelectorAll('[data-clipboard-copy]');
	buttons.forEach((button) => {
		button.addEventListener('click', (event) => {
			event.preventDefault();
			const text = button.dataset.clipboardCopy;
			navigator.clipboard.writeText(text);
		});
	});
}

function initBackToTopButtons() {
	const buttons = document.querySelectorAll('[data-back-to-top]');
	buttons.forEach((button) => {
		button.addEventListener('click', (event) => {
			window.scrollTo({ behavior: 'smooth', top: 0 });
		});
	});
}

function throttle(func, limit) {
	let inThrottle = false;
	return function () {
		if (!inThrottle) {
			func.apply(this, arguments);
			inThrottle = true;

			setTimeout(function () {
				inThrottle = false;
			}, limit);
		}
	};
}

/**
 * Replaces the current window state with updated search params.
 * @param params {Record<string, string | null>}
 * @param url {URL | undefined}
 */
function updateSearchParams(params, url = undefined) {
	url = url ?? new URL(window.location.href);
	const p = url.searchParams;
	for (const [k, v] of Object.entries(params)) {
		v == null ? p.delete(k) : p.set(k, v);
	}
	window.history.replaceState({}, '', url);
}

window.addEventListener('DOMContentLoaded', initClipboardCopyButtons);
window.addEventListener('DOMContentLoaded', initBackToTopButtons);
